<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mizbMR/images/cover.jpg?1685327252694" alt="This image is the cover for the book Peter's Chair"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peter's Chair
      </h1>
      <p class="bookDescription body article font2">
        <p>Pope Dominic V is dying. Among the cardinals called to Rome is Brian Blair of the United States: young, headstrong, gay, and accompanied by his lover and aide, Monsignor William Hart. When the pope passes, the cardinals meet in the papal conclave to choose his successor. To everyone's surprise, especially his own, Cardinal Blair is elected.</p> <p>Taking the name John XXIV, Blair immediately sets out to change church policy in the area of human rights. In the face of strong opposition, he approves birth control and urges equal treatment of those in the gay community.</p> <p>In the midst of controversy and an attempt on the new pope's life, evidence that a group of conservative priests have invited Satan into St. Peter's Basilica comes to light. Now Brian and those closest to him must battle not only earthly foes but the devil himself.</p><p><img height="150" src="http://i1356.photobucket.com/albums/q726/ArielTachna13/reviewertoppick2_zps6a2d661a.png" width="150"/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Simpson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54e9bcdc